import { Heading } from "@digipost/dds-heading-react";
import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

import {
  SiteImproveActions,
  SiteImproveCategories,
  siteImproveEvent,
} from "../analytics/SiteImprove";
import { post } from "../infrastructure/digipost-fetch";
import { Dispatch } from "../infrastructure/redux/actions";
import { fetchEntrypointAction } from "../infrastructure/redux/app/app-actions";
import { ReduxState } from "../infrastructure/redux/state";
import Translated from "../infrastructure/Translated";
import { useRootPath } from "../infrastructure/useRootPath";
import { useTranslate } from "../infrastructure/useTranslate";
import AuthView from "./AuthView";
import styles from "./Login.module.css";
import { LoginType } from "./loginType";

const Login: FC = () => {
  const [authUrl, setAuthUrl] = useState<string | undefined>();
  const [type, setType] = useState<LoginType | undefined>();

  const translate = useTranslate();
  const navigate = useNavigate();
  const rootPath = useRootPath();

  const dispatch = useDispatch<Dispatch>();
  const authIsRegistrering = useSelector(
    (state: ReduxState) => state.user.authIsRegistrering,
  );
  const fetchEntrypoint = (): Promise<void> =>
    dispatch(fetchEntrypointAction());

  useEffect(() => {
    document.title = `Digipost - ${translate("auth.login_header")}`;
  }, [translate]);

  useEffect(() => {
    if (authIsRegistrering) {
      navigate("../registrer");
    }
  }, [authIsRegistrering, navigate]);

  const getLoginUrl = async (authType: LoginType): Promise<void> => {
    siteImproveEvent({
      category: SiteImproveCategories.SIGNERING_VIRKSOMHET,
      action:
        authType === "BANKID2"
          ? SiteImproveActions.BANKID2
          : SiteImproveActions.BUYPASS,
    });

    const body = {
      returnUrl: window.location.pathname,
      authenticationRole: "REGISTRATION",
      authenticationType: authType,
      successCallback: "success",
      errorCallback: "error",
      elevation: true,
      solvency: true,
    };
    const response = await post(
      "/post/api/secureauthentication/link",
      body,
      undefined,
    );

    setAuthUrl(response.headers.get("location") as string);
    setType(authType);

    window.signicat = async (params) => {
      const parameter = params || {};

      if (parameter.status === "success") {
        await fetchEntrypoint();
        navigate(`${rootPath}/bedrift/registrer`);
      } else if (
        parameter.message === "AUTENTISERING_AVBRUTT" ||
        parameter.message === "AUTENTISERING_COOKIES_DISABLET"
      ) {
        navigate(`${rootPath}/bedrift`);
      } else {
        navigate(`${rootPath}/bedrift/feil`);
        console.error(params);
      }

      window.signicat = undefined;
    };
  };

  return (
    <main className={styles.centerBlock}>
      <Heading level={1} size="large">
        <Translated
          textKey={type ? `auth.login_header_${type}` : "auth.login_header"}
        />
      </Heading>

      {!authUrl ? (
        <AuthView onAuthRequestClick={getLoginUrl} showHelpLinks={true} />
      ) : (
        <iframe
          src={authUrl}
          title={
            type
              ? translate(`auth.login_header_${type}`)
              : translate("auth.login_header")
          }
          frameBorder="0"
          scrolling="no"
          style={{ width: "100%", height: "333px" }}
        />
      )}
    </main>
  );
};

export default Login;
